/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Showpassword1Inputs */

const en_showpassword1 = /** @type {(inputs: Showpassword1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show password`)
};

const de_showpassword1 = /** @type {(inputs: Showpassword1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwort anzeigen`)
};

/**
* | output |
* | --- |
* | "Show password" |
*
* @param {Showpassword1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const showpassword1 = /** @type {((inputs?: Showpassword1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Showpassword1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_showpassword1(inputs)
	return de_showpassword1(inputs)
});
export { showpassword1 as "showPassword" }